import { IEstimationUserChosenFiltersSchema } from '../../../repositories/price-estimator/entities/estimation/EstimationUserChosenFiltersSchema';
import { EPreciseFilterNames, EPreciseFilterValues, TPreciseFiltersState } from '../../../types/redux/preciseFilters';

/**
 * Преобразуем массив фильтров в объект, который хранится в сторе
 */
export function preparePreciseFilters(rawFilters: IEstimationUserChosenFiltersSchema[]) {
  return rawFilters.reduce((preciseFilters, filter) => {
    const { key, value } = filter;

    preciseFilters[key as unknown as EPreciseFilterNames] = value as unknown as EPreciseFilterValues[];

    return preciseFilters;
  }, {} as TPreciseFiltersState);
}
